module.exports = __webpack_public_path__ + "img/43_32.02e7dd17.png";